
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/money-for-business",
      function () {
        return require("private-next-pages/money-for-business.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/money-for-business"])
      });
    }
  